// How a currency code is written on screen, per region. The mappings live in src/config/currency-display.json.
// Display only: the stored code (USD) is what the API, the BNA rate check and the exports keep using.
// Keep this file free of runtime imports: node:test loads it directly with type stripping.

/** Region code (CO, AR) → stored currency code → the code that region shows. */
export type CurrencyLabels = Record<string, Record<string, string>>

/** The code as `region` writes it; a code the region does not map is shown as stored. */
export function currencyLabel(code: string, region: string, labels: CurrencyLabels): string {
  return labels[region]?.[code] ?? code
}
